<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-left">
        <!-- コピーライト削除 -->
      </div>
      <div class="footer-right">
        <slot></slot>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
.footer {
  background-color: #195983;
  padding: 1rem 1.5rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
}

.footer-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-left {
  color: #FFF;
  font-size: 0.875rem;
}

.footer-right {
  display: flex;
  gap: 0.75rem;
}

/* ボタンスタイルのオーバーライド */
:deep(.btn-primary), :deep(.btn-secondary) {
  background-color: #ffed27;
  color: #195983;
  border: none;
  height: 48px;
  border-radius: 11px;
}

:deep(.btn-danger) {
  background-color: #dc3545;
  color: white;
  border: none;
  height: 48px;
  border-radius: 11px;
}

:deep(.btn-primary:hover), :deep(.btn-secondary:hover) {
  background-color: #f5e000;
  color: #195983;
}

:deep(.btn-danger:hover) {
  background-color: #c82333;
  color: white;
}
</style>
